import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/images/sepak.png'


const _hoisted_1 = { class: "fixed top-0 z-50 w-full bg-white shadow-md" }
const _hoisted_2 = { class: "flex justify-between items-center mx-6 sm:mx-4 md:mx-12 xl:mx-20" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "aspect-w-16 aspect-h-13" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    loading: "eager"
  })
], -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "hidden text-xl xl:flex text-primary" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search" }, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "inline-block relative" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-shopping-cart" }, null, -1)
const _hoisted_10 = {
  key: 0,
  class: "grid absolute bottom-4 left-4 place-content-center w-4 h-4 text-xs text-white bg-red-500 rounded-full"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "ml-8 cursor-pointer" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-question" })
], -1)

import { computed } from "vue";
import { useStore } from "vuex";


export default /*#__PURE__*/_defineComponent({
  emits: ["toggle-cart", "toggle-route"],
  setup(__props, { emit }) {

const store = useStore();
const shoppingCartList = computed(() => store.state.shoppingCartList);


const toggleCart = () => emit("toggle-cart");
const toggleRoute = (path: string) => emit("toggle-route", path);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("nav", _hoisted_2, [
      _createElementVNode("div", {
        class: "py-5 w-14 cursor-pointer",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (toggleRoute('/')))
      }, _hoisted_4),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", {
          class: "ml-8 cursor-pointer",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (toggleRoute('/browse')))
        }, _hoisted_7),
        _createElementVNode("div", {
          class: "ml-8 cursor-pointer",
          onClick: toggleCart
        }, [
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            (_unref(shoppingCartList).length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_unref(shoppingCartList).length), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        _hoisted_11
      ])
    ])
  ]))
}
}

})